import React from 'react';
import { motion } from 'framer-motion'; // Import Framer Motion for animations
import CorrosionData from '../data/CorrosionData';
import WhyCorrosionImage from '../assets/why-corrosion.png';  
import '../styles/corrosion.css';
import Footer from '../components/Footer';
import Call from '../components/Call';

function Corrosion() {
  return (
    <motion.div 
      className='corrosion-container'
      initial={{ opacity: 0 }} 
      animate={{ opacity: 1 }} 
      transition={{ duration: 0.8 }}
    >
      {/* Hero Section */}
      <motion.div 
        className="corrosion-hero"
        initial={{ y: -50, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.8, ease: 'easeOut' }}
      >
        <h1>Corrosion Control</h1>
        <p>
          At <span>NEXTCASTLE ENERGY LIMITED</span>, we specialize in advanced corrosion prevention, 
          control, and mitigation solutions for the oil and gas industry. Corrosion is a major 
          challenge that affects operational efficiency, asset lifespan, and safety. Our expertise 
          ensures that infrastructure, pipelines, and equipment remain durable, reliable, and 
          compliant with industry standards.
        </p>
      </motion.div>

      {/* Corrosion Protection Capabilities */}
      <div className="corrosion-services">
        <motion.div 
          className="corrosion-service-text"
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          <h2>Our Corrosion Protection Capabilities</h2>
        </motion.div>

        <div className="corrosion-service-cards">
          {CorrosionData.map((item) => (
            <motion.div 
              key={item.id} 
              className="corrosion-card"
              whileHover={{ scale: 1.05 }}
              transition={{ duration: 0.3 }}
            >
              <div className="title"><h2>{item.title}</h2></div>
              <div className="desc"><p>{item.description}</p></div>
            </motion.div>
          ))}
        </div>
      </div>

      {/* Why Choose Us */}
      <div className="why-corrosion-container">
        <motion.div 
          className="why-corrosion-image"
          initial={{ opacity: 0, x: -50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
        >
          <img src={WhyCorrosionImage} alt="nextcastle-why-choose-us" />
        </motion.div>                                  

        <motion.div 
          className="why-corrosion-text"
          initial={{ opacity: 0, x: 50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
        >
          <h2>Why Choose <span>NEXTCASTLE ENERGY LIMITED</span> for Corrosion Protection?</h2>
          <ul>
            <li><span>Industry Expertise:</span> Years of experience in corrosion prevention and management across diverse oil and gas infrastructures.</li>
            <li><span>Advanced Technology:</span> Cutting-edge solutions such as real-time corrosion monitoring and predictive analytics for proactive asset protection.</li>
            <li><span>Regulatory Compliance:</span> All services align with international safety, quality, and environmental standards to ensure operational integrity.</li>
            <li><span>Cost-Effective Solutions:</span> We optimize resources to deliver long-lasting, high-value corrosion protection services.</li>
          </ul>
        </motion.div>
      </div>

      <Call />
      <Footer />
    </motion.div>
  );
}

export default Corrosion;
